var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"","hover":"","items":_vm.products},scopedSlots:_vm._u([{key:"cell(id)",fn:function(data){return [_c('router-link',{attrs:{"to":{
        name: 'SpecificProduct',
        params: { id: _vm.accounts, productid: data.value }
      }}},[_vm._v(_vm._s(data.value))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }